<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  large?: boolean
  disabled?: boolean
  modelValue: string | null
  smallText?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  large: false,
  disabled: false,
  smallText: false
})
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const inputData = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
</script>

<template>
  <label class="radio-button">
    <input v-model="inputData" type="radio" name="option" v-bind="$attrs" />
    <div class="radio-circle"></div>
    <span class="radio-label" :class="{ smallText }"><slot /></span>
  </label>
</template>

<style scoped lang="scss">
.radio-buttons {
  display: flex;
  flex-direction: column;
  color: white;
}

.radio-button {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;

  .smallText {
    @include h6-5;
  }
}

.radio-button input[type='radio'] {
  display: none;
}

.radio-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid $primary-green;
  position: relative;
  margin-right: 10px;
}

.radio-circle::before {
  content: '';
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: all 0.2s ease-in-out;
}

.radio-button input[type='radio']:checked + .radio-circle::before {
  transform: translate(-50%, -50%) scale(1);
}

.radio-button input[type='radio']:checked + .radio-circle::before {
  background-color: $primary-green;
}

.radio-label {
  @include h4-6;
}

.radio-button:hover .radio-label {
  color: $primary-green;
}
</style>
